export const endpoints = {
  wishes: '/discover/wishes'
};
